import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import CircularProgress from '@material-ui/core/CircularProgress';

import apImg from '../images/ap.png';
import gpImg from '../images/gp.png';
import postboxImg from '../images/postbox.png';
import FirebaseEventManager from '../../utils/firebaseEventManager.js';

function VerifyAccount(props) {
  const intl = useIntl();
  const { verifyAccountAgain, email } = props;
  const firebaseEventManager = new FirebaseEventManager();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { classes } = props;
  async function verifyAccountAgainWrap(){
    setIsSubmitting(true);
    await verifyAccountAgain();
    setIsSubmitting(false);
  }

  useEffect(() => {
    firebaseEventManager.verifyPageLanded();
  }, []);

  const email_verify_page_desc = intl.formatMessage({
    id: 'email_verify_page_desc',
  }).replace('%s', email);
  const email_verify_page_resend_tips = intl.formatMessage({
    id: 'email_verify_page_resend_tips',
  });
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <p className={classes.title}>
          <FormattedMessage id="email_verify_page_title"></FormattedMessage>
        </p>
        <img src={postboxImg} width="100" alt="" />
        <p className={classes.description} dangerouslySetInnerHTML={{ __html: email_verify_page_desc }}></p>
        <button className={classes.verifyActionBtn} onClick={verifyAccountAgainWrap}>
          {isSubmitting ? (
            <CircularProgress size={20} color="inherit" id="signInLoading" />
          ) : (
            <FormattedMessage id="email_verify_page_sign_in_now" />
          )}
        </button>
      </div>
      <p className={classes.signInFooter} dangerouslySetInnerHTML={{ __html: email_verify_page_resend_tips }}></p>
      <p className={classes.imageContainer}>
        <img
          onClick={() => props.downloadApp({ platform: 'ios', page: 'verifyemail' })}
          className={classes.apImg}
          src={apImg}
          width="136"
          alt=""
        />
        <img
          onClick={() => props.downloadApp({ platform: 'android', page: 'verifyemail' })}
          className={classes.gpImg}
          src={gpImg}
          width="134"
          alt=""
        />
      </p>
    </div>
  );
}

const styles = (theme) => ({
  root: {
    width: '100%',
    minHeight: `calc(100vh - 128px)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: '#F8F8F8',
    margin: '40px 0',
    fontFamily: 'Open Sans',
  },
  container: {
    maxWidth: 375,
    background: '#FFFFFF',
    border: '1px solid #E1E1E1',
    boxSizing: 'border-box',
    borderRadius: 4,
    padding: '32px 40px',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '26px',
    lineHeight: '36px',
    textAlign: 'center',
    color: '#1A1A1A',
    marginBottom: '16px',
    maxWidth: 375,
  },
  description: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '15px',
    lineHeight: '20px',
    textAlign: 'center',
    color: '#757575',
    margin: '24px 0 40px 0',
    maxWidth: 375,
  },

  verifyActionBtn: {
    width: '100%',
    height: 48,
    background: '#FD9728',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 17,
    lineHeight: '23px',
    textAlign: 'center',
    color: '#FFFFFF',
    border: 'initial',
    cursor: 'pointer',
    '&:hover': {
      filter: 'brightness(105%)',
    },
  },
  signInFooter: {
    fontSize: '15px',
    lineHeight: '20px',
    textAlign: 'center',

    color: '#757575',
    margin: '16px 0',
  },
  imageContainer: {
    textAlign: 'center',
  },
  apImg: {
    marginRight: '20px',
    cursor: 'pointer',
  },
  gpImg: {
    cursor: 'pointer',
  },
});

export default withStyles(styles)(VerifyAccount);
